import { Helmet } from "react-helmet";

const SITE_URL = "https://www.osiyatech.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

const Seo = ({ title, description, path = "", keywords = "" }) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes("Osiyatech") ? title : `${title} | Osiyatech`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:site_name" content="Osiyatech" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </Helmet>
  );
};

export default Seo;
